import { toBoolean } from '../../utils/booleanUtils';

export function isLocationActive(loc) {
  if (!loc) return true;
  return toBoolean(loc.is_active);
}

export function getDisabledLocationsFromSelection(locations, selectedIds) {
  if (!selectedIds?.length || !locations?.length) return [];
  const idSet = new Set(selectedIds.map((id) => String(id)));
  return locations.filter((loc) => idSet.has(String(loc.id)) && !isLocationActive(loc));
}

export function hasDisabledLocationFilter(locations, selectedIds) {
  return getDisabledLocationsFromSelection(locations, selectedIds).length > 0;
}

export function findLocationById(locations, id) {
  return locations.find((loc) => String(loc.id) === String(id));
}

/** Plain-text label for native select options (badges are not supported inside option). */
export function formatLocationFilterOptionLabel(loc) {
  if (!loc?.name) return String(loc?.id ?? '');
  if (!isLocationActive(loc)) return `${loc.name} · DISABLED`;
  return loc.name;
}
